import styled from 'styled-components';

import { Box } from '@mui/material';

export const MainContentContainer = styled(Box)`
  background-color: var(--mui-palette-background-default);
  flex-grow: 1;
  padding: 4rem 8rem;
`;
